import { Grid } from "@mui/material";
import DeleteCircle from "assets/DeleteCircle";
import MultiCard from "assets/multiCard";
import {
  clearAllCardSelection,
  setActiveActionCard,
  setAllCards,
  setCopyActionPopupEnabled
} from "components/app/App.slice";
import Button from "components/common/Button";
import MarkCompleteButton from "components/common/MarkCompleteButton";
import { setFeedbackDetails } from "components/common/Snackbar/snackbar.slice";
import ActionCardDialogsContext from "components/features/ActionCard/Context";
import { CardList } from "Interface/interface";
import React from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { ABOVE_PROPERTY, accessTypes } from "utils/CommonConstants";
import { getUserHltId } from "utils/CommonFunctions";
import { planTypes } from "utils/Types";

function MultiSelectButtons(props: any) {
  const { planId, multiCardSelect, section, planType, handleMultiSelectMode } = props;
  const dispatch = useAppDispatch();
  const isActionHighlight = useAppSelector((state: any) => state.myplans?.MyPlans.isActionHighlight);
  const selectedCards: any = useAppSelector((state) => state?.app?.selectedCards);
  const individualActionList = useAppSelector((state: any) => state.individualAction.list);
  const selectedMyPlanDetail: any = useAppSelector((state) => state.myPlanDetails.myPlanDetails);
  const isTemplatePlan = selectedMyPlanDetail.innCode === ABOVE_PROPERTY;

  const { setIsOpenDeleteActionDialog, setIsOpenCopyActionDialog, setIsOpenAssigneeDialog } =
    React.useContext(ActionCardDialogsContext);

  const sectionCards = (cards: CardList[]) => {
    if (isActionHighlight) {
      return cards?.filter((item) => item.assignee?.includes(getUserHltId()));
    }
    return cards;
  };

  const setMultipleCards = () => {
    if (section) {
      const cards = sectionCards(section.cards);
      const payload = {
        planId,
        sectionId: section?.id,
        cardList: cards
      };
      dispatch(setAllCards(payload));
    } else {
      const payload = {
        cardList: individualActionList
      };
      dispatch(setAllCards(payload));
    }
  };

  const copyActions = (e: React.SyntheticEvent) => {
    dispatch(setCopyActionPopupEnabled(true));
    setIsOpenCopyActionDialog(true);
  };
  const deleteCards = (e: React.SyntheticEvent) => {
    const checkEditAble = selectedCards?.cardList?.every((element: any) => element.cardEditable === "N");
    if (checkEditAble) {
      dispatch(
        setFeedbackDetails({
          shouldShow: true,
          type: "action",
          setState: setFeedbackDetails({ shouldShow: false }),
          message: `Modifications can't be made. This is preconfigured to ensure a successful and on-time implementation.`,
          actionType: "edit"
        })
      );
    } else {
      setIsOpenDeleteActionDialog(true);
    }
  };

  const disabledMultiSelect = () => {
    if (section) {
      const cards = sectionCards(section?.cards);
      if (!cards.length) return true;
      return cards.length === selectedCards?.cardList?.length;
    }
    return false;
  };

  const getButtonsList = () => {
    if (multiCardSelect) {
      return (
        <>
          <Button
            width="120px"
            variant="secondary"
            label="Exit Selection mode"
            onClick={() => {
              handleMultiSelectMode();
              dispatch(clearAllCardSelection());
            }}
            startIcon={<DeleteCircle color={tokens.Icon.General.Color} />}
          />
          <Button
            variant="secondary"
            disabled={disabledMultiSelect()}
            label="Select All"
            startIcon={<MultiCard color={tokens.Icon.General.Color} disabled={disabledMultiSelect()} />}
            onClick={setMultipleCards}
          />
          <Button
            disabled={!selectedCards?.cardList?.length}
            variant="secondary"
            label="Clear Selection"
            onClick={() => {
              dispatch(clearAllCardSelection());
            }}
          />
        </>
      );
    } else {
      return (
        <Button
          variant="secondary"
          label="Select multiple Actions"
          accessType={accessTypes.update}
          startIcon={<MultiCard color={tokens.Icon.General.Color} />}
          onClick={() => handleMultiSelectMode()}
        />
      );
    }
  };
  const getButtonsListSelected = () => {
    return (
      <>
        {planType === planTypes.AllPlans ? (
          <>
            {" "}
            {multiCardSelect && (
              <Button
                accessType={accessTypes.update}
                variant="secondary"
                label="Copy action(s) to plan"
                onClick={copyActions}
              />
            )}
          </>
        ) : (
          <Grid flexWrap={"wrap"} item md={12} display={"flex"} gap={"8px"}>
            {!isTemplatePlan && (
              <>
                <MarkCompleteButton
                  width={"auto"}
                  variant="secondary"
                  source={{ source: "section", sectionId: section?.id }}
                />
                <Button
                  width="100px"
                  variant="secondary"
                  label="Assign"
                  onClick={(e) => {
                    dispatch(setActiveActionCard({}));
                    setIsOpenAssigneeDialog(true);
                  }}
                />
              </>
            )}
            <Button
              width="100px"
              variant="secondary"
              label="Delete"
              onClick={deleteCards}
              accessType={accessTypes.delete}
            />
          </Grid>
        )}
      </>
    );
  };

  return (
    <>
      {planType !== planTypes.MulipleAssign && getButtonsList()}
      {selectedCards?.cardList?.length > 0 && selectedCards.sectionId === section?.id && getButtonsListSelected()}
    </>
  );
}

export default MultiSelectButtons;
